import { VkCallbackPage } from '@/app/pages/auth/vk/vk-callback-page';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/auth/vk-callback')({
  validateSearch: z.object({
    code: z.string().optional(),
    device_id: z.string().optional(),
    state: z.string().optional(),
  }),
  component: VkCallbackPage,
});
